import axios from 'axios/index';
import React, {PureComponent} from 'react';
import {Link} from 'react-router-dom';

import { Classes, Overlay } from "@blueprintjs/core";
import toastr from 'toastr';
import { getCurrentUserId, getJwt } from '../../services/authService';
import http from '../../services/httpService';

export default class FacebookLoginFailedModal extends PureComponent{
    state={
        overlayIsOpen: false,
    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }

    componentDidMount(){
        this.setState({
            overlayIsOpen: this.props.showModal,
        })
    }
    componentDidUpdate(){
        if (this.state.overlayIsOpen !== this.props.showModal){
            this.setState({
                overlayIsOpen: this.props.showModal
            })
        }
    }
    render(){
        return(
            <Overlay
                onClose={this.props.handleClose} className={Classes.OVERLAY_SCROLL_CONTAINER} isOpen={this.state.overlayIsOpen}
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="modal-field" style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <p className="modal-close-button" onClick={ () =>{this.props.handleClose()} }><i className="fas fa-times"></i></p>
                    <div className="onboarding-panel">
                        <h1 className="m-m-b">Facebook Login Failed</h1>
                        <div className="separator"></div>
                        <div className="form-group m-m-b">
                            <span>You have probably created your account with <strong>Create an account</strong> option,
                                so you can't access your account with <strong>Login with Facebook</strong> option.<br/>
                                You can login with your email and password, or you can <strong>Reset</strong> your password.
                            </span>
                        </div>
                        <div className="separator m-m-b"></div>
                        <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                            <button
                                disabled={ false }
                                onClick={ () =>{
                                    this.props.handleClose()
                                } }
                                name="cancel_delete_tag"
                                id="cancel_delete_tag"
                                type="button"
                                className='btn-action btn-sm m-sm-b center'>Login</button>
                            <Link className='text-center' to='forgot-password'>Reset password</Link>
                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}